import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPolymerprojectComponent } from './simple-icons-polymerproject.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPolymerprojectComponent ],
    exports:      [ SimpleIconsPolymerprojectComponent ],
    bootstrap:    []
})
export class SimpleIconsPolymerprojectModule {}
